import {
  FETCH_TEACHER_INFORMATION_BEGIN,
  FETCH_TEACHER_INFORMATION_FULFILLED,
  FETCH_TEACHER_INFORMATION_REJECTED
} from "../actions/teacherActions";

const initialStateTeacherStudents = {
  loading: false,
  error: null,
  result: [],
  statusCode: null
};

export function teacherStudentReducer(
  state = initialStateTeacherStudents,
  action
) {
  switch (action.type) {
    case "FETCH_TEACHER_STUDENTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_TEACHER_STUDENTS_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_TEACHER_STUDENTS_FAILURE": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    default:
      return state;
  }
}

const FetchTeacher = (
  state = {
    teacher: {
      name: "null",
      email: null,
      fullAccess: null,
      programmes: []
      // classes: {
      //   className: null,
      //   schoolName: null
      // }
    },
    fetching: false,
    fetech: false,
    error: null
  },
  action
) => {
  switch (action.type) {
    case "FETCH_TEACHER": {
      return { ...state, fetching: true };
    }
    case "FETCH_TEACHER_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    case "FETCH_TEACHER_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        teacher: action.payload
      };
    }
    case "FETCH_TEACHER_STUDENTS": {
      return { ...state, fetching: true };
    }
    case "FETCH_TEACHER_STUDENTS_REJECTED": {
      return { ...state, fetching: false, error: action.payload };
    }
    case "FETCH_TEACHER_STUDENTS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        students: action.payload
      };
    }

    default: {
      return {
        ...state
      };
    }
  }
};

const INIT_TEACHER_INFORMATION = {
  error: null,
  loading: false,
  result: {
    schools: [
      {
        id: null,
        classes: [
          {
            id: null,
            name: "",
            schoolId: null
          }
        ],
        name: null,
        adresses: []
      }
    ],
    id: null,
    name: "",
    email: "",
    fullAccess: false,
    purchaser: false,
    activatedAccount: false
  },
  statusCode: null
};

export function teacherInformationReducer(
  state = INIT_TEACHER_INFORMATION,
  action = {}
) {
  // PLEASE NOTE:
  // below actions are unused
  // kept for instance - Ajinkya
  switch (action.type) {
    case FETCH_TEACHER_INFORMATION_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_TEACHER_INFORMATION_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_TEACHER_INFORMATION_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    case "ADD_CLASS": {
      state.result.programmes
        .find(x => x.id === action.payload.programid)
        .classes.push(action.payload.newClass);

      return {
        ...state
      };
    }
    case "DELETE_CLASS": {
      state.result.programmes.forEach(program => {
        var index = program.classes.findIndex(
          x => x.id === action.payload.classid
        );
        if (index !== -1) program.classes.splice(index, 1);
      });

      return {
        ...state
      };
    }
    case "UPDATE_CLASS": {
      //Uppdatera bara namnet & inriktninge som visas på startsidan...detta objektet har en annan struktur än det som visas för läraren...
      //annars hade man ju kunna ersätta objektet rakt av....

      var moveToProgramIndex;
      var removeFromProgramIndex;
      var classToMove;
      var removeFromClassIndex;
      var currentProgramIndex = 0;

      state.result.programmes.forEach(program => {
        var index = program.classes.findIndex(
          x => x.id === action.payload.updateClass.id
        );
        var classToUpdate = program.classes[index];

        if (program.id === action.payload.updateClass.programme.id) {
          moveToProgramIndex = currentProgramIndex;
        }

        if (classToUpdate) {
          if (
            classToUpdate.programme.id !==
            action.payload.updateClass.programme.id
          ) {
            removeFromProgramIndex = currentProgramIndex;
            removeFromClassIndex = index;
            classToMove = classToUpdate;
          }

          classToUpdate.name = action.payload.updateClass.name;
          classToUpdate.orientation = action.payload.updateClass.orientation;
          classToUpdate.programme = action.payload.updateClass.programme;
          classToUpdate.teachers = action.payload.updateClass.teachers;
        }

        currentProgramIndex += 1;
      });

      if (classToMove) {
        state.result.programmes[removeFromProgramIndex].classes.splice(
          removeFromClassIndex,
          1
        );
        state.result.programmes[moveToProgramIndex].classes.push(classToMove);
      }

      return {
        ...state
      };
    }
    case "ADD_STUDENT": {
      let classObj = null;

      state.result.programmes.forEach(program => {
        program.classes.forEach(clas => {
          if (clas.id === action.payload.classid) {
            classObj = {
              id: clas.id,
              name: clas.name,
              orientation: clas.orientation,
              programme: clas.programme
            };
          }
        });
      });

      let studentObj = {
        activatedAccount: false,
        class: classObj,
        email: action.payload.newStudent.email,
        id: action.payload.newStudent.id,
        name: action.payload.newStudent.name
      };

      state.result.programmes.forEach(program => {
        program.classes.forEach(clas => {
          if (clas.id === action.payload.classid) {
            clas.students.push(studentObj);
          }
        });
      });

      return {
        ...state
      };
    }
    case "UPDATE_TEACHER_STUDENT": {
      var isOnSameClass = false;

      state.result.programmes.forEach(program => {
        var studentClass = program.classes.find(
          clas => clas.id === action.payload.student.class.id
        );
        if (typeof studentClass !== "undefined") {
          isOnSameClass =
            studentClass.students.filter(
              student => student.id === action.payload.student.id
            ).length > 0;

          if (isOnSameClass) {
            var studentToUpdate = studentClass.students.find(
              x => x.id === action.payload.student.id
            );
            studentToUpdate.name = action.payload.student.name;
            studentToUpdate.email = action.payload.student.email;
          } else {
            studentClass.students.push({
              id: action.payload.student.id,
              name: action.payload.student.name,
              activatedAccount: action.payload.student.activatedAccount,
              email: action.payload.student.email
            });
          }
        }
      });

      //If the student is moved to other class, then remove the stundent from the old class
      if (!isOnSameClass) {
        state.result.programmes.forEach(program => {
          program.classes.forEach(clas => {
            if (clas.id !== action.payload.student.class.id) {
              var index = clas.students.findIndex(
                x => x.id === action.payload.student.id
              );
              if (index > -1) {
                clas.students.splice(index, 1);
              }
            }
          });
        });
      }

      return { ...state };
    }
    default: {
      return { ...state };
    }
  }
}
export default FetchTeacher;
